export default __webpack_public_path__ + "static/media/menu-char.b2b0bee9.svg";